import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import { setMetaTags } from '../../redux/actions';


class getMetaTags extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'meta tags Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch,payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        this.call(this.Config.api.requests.getMetaTags, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        let key = this.payload.route;
        if(this.payload.objectId !== undefined) {
            key = this.payload.objectId;
        }

        this.dispatch(setMetaTags({route: [key], val: this.response.data.tags}));
    }
}

export default getMetaTags;